import { 
  FaTachometerAlt, 
  FaCloudUploadAlt, 
  FaDumbbell, 
  FaUser, 
  FaChalkboardTeacher, 
  FaFileInvoiceDollar, 
  FaCog, 
  FaTag, 
  FaBloggerB, 
  FaHome 
} from "react-icons/fa";

export const SidebarNavigation = [
  {
    label: "Dashboard",
    icon: <FaTachometerAlt />,
    link: "/dashboard",
  },
  {
    label: "Upload Media",
    icon: <FaCloudUploadAlt />,
    link: "/upload-media",
  },
  {
    label: "Notification",
    icon: <FaCloudUploadAlt />,
    link: "/notification",
  },
  {
    label: "Plans Manager",
    icon: <FaDumbbell />,
    subItems: [
      { label: "Workout Plans", target: "/workout-plans" },
      { label: "Single Workouts", target: "/single-workout" },
      { label: "Add New Recipe", target: "/add-new-recipe" },
      { label: "Meditation Overview", target: "/add-recipe-motivation" },
      { label: "Chalange", target: "/chalanges" },
    
    ],
  },
  {
    label: "Update Tag",
    icon: <FaTag />,
    link: "/update-workout-tag",
  },
  {
    label: "Users",
    icon: <FaUser />,
    link: "/users",
  },
  {
    label: "Trainers",
    icon: <FaChalkboardTeacher />,
    link: "#",
  },
  {
    label: "Report",
    icon: <FaFileInvoiceDollar />,
    link: "#",
  },
  {
    label: "Settings",
    icon: <FaCog />,
    link: "#",
  },
  {
    label: "Blog",
    icon: <FaBloggerB />,
    link: "/blog",
  },
  {
    label: "Landing Page",
    icon: <FaHome />,
    link: "/landing",
  },
];
